module.exports = __webpack_public_path__ + "img/hr-green-croton-05.67ce3e31.png";